var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThirty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.6064L29.274 25.9912L18.774 52L14.028 46.9806L7 47.6153L17.5 21.6064Z",
    fill: "#BB3027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.138 21L18.365 25.3847L28.865 51.3936L33.61 46.3742L40.638 47.0088L30.138 21Z",
    fill: "#BB3027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L27.322 2.6821L30.835 1.00334L32.69 4.42624L36.55 3.91515L37.256 7.74379L41.085 8.4504L40.574 12.31L43.997 14.1652L42.318 17.6779L45 20.5L42.318 23.3221L43.997 26.8348L40.574 28.69L41.085 32.5496L37.256 33.2562L36.55 37.0848L32.69 36.5738L30.835 39.9967L27.322 38.3179L24.5 41L21.678 38.3179L18.165 39.9967L16.31 36.5738L12.45 37.0848L11.744 33.2562L7.9152 32.5496L8.4262 28.69L5.0033 26.8348L6.6821 23.3221L4 20.5L6.6821 17.6779L5.0033 14.1652L8.4262 12.31L7.9152 8.4504L11.744 7.74379L12.45 3.91515L16.31 4.42624L18.165 1.00334L21.678 2.6821L24.5 0Z",
    fill: "#352929"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.5C39 28.5081 32.508 35 24.5 35C16.492 35 10 28.5081 10 20.5C10 12.4919 16.492 6 24.5 6C32.508 6 39 12.4919 39 20.5Z",
    fill: "#372F2A",
    stroke: "#403831",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35 26.299 30.299 31 24.5 31C18.701 31 14 26.299 14 20.5C14 14.701 18.701 10 24.5 10C30.299 10 35 14.701 35 20.5Z",
    fill: "#544E48"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 41,
    height: 52
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.6064L29.274 25.9912L18.774 52L14.028 46.9806L7 47.6153L17.5 21.6064Z",
    fill: "#BB3027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.138 21L18.365 25.3847L28.865 51.3936L33.61 46.3742L40.638 47.0088L30.138 21Z",
    fill: "#BB3027"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L27.322 2.6821L30.835 1.00334L32.69 4.42624L36.55 3.91515L37.256 7.74379L41.085 8.4504L40.574 12.31L43.997 14.1652L42.318 17.6779L45 20.5L42.318 23.3221L43.997 26.8348L40.574 28.69L41.085 32.5496L37.256 33.2562L36.55 37.0848L32.69 36.5738L30.835 39.9967L27.322 38.3179L24.5 41L21.678 38.3179L18.165 39.9967L16.31 36.5738L12.45 37.0848L11.744 33.2562L7.9152 32.5496L8.4262 28.69L5.0033 26.8348L6.6821 23.3221L4 20.5L6.6821 17.6779L5.0033 14.1652L8.4262 12.31L7.9152 8.4504L11.744 7.74379L12.45 3.91515L16.31 4.42624L18.165 1.00334L21.678 2.6821L24.5 0Z",
    fill: "#352929"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.5C39 28.5081 32.508 35 24.5 35C16.492 35 10 28.5081 10 20.5C10 12.4919 16.492 6 24.5 6C32.508 6 39 12.4919 39 20.5Z",
    fill: "#372F2A",
    stroke: "#403831",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35 26.299 30.299 31 24.5 31C18.701 31 14 26.299 14 20.5C14 14.701 18.701 10 24.5 10C30.299 10 35 14.701 35 20.5Z",
    fill: "#544E48"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.917 -6L46 16.5L4.5 30L-1.5 6.17949L34.917 -6Z",
    fill: "#544E48"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7L16.175 8.8248L18 9.5L16.175 10.1752L15.5 12L14.825 10.1752L13 9.5L14.825 8.8248L15.5 7Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_112",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_112",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirty);
export default __webpack_public_path__ + "static/media/thirty.7e17ddee89c56ce774991732bb2c8322.svg";
export { ForwardRef as ReactComponent };